// extracted by mini-css-extract-plugin
module.exports = {"input":"_1JbIfv","open":"_14wwaG","closeArrow":"_3oCgfj"};